module.exports = __webpack_public_path__ + "static/email-26a6b95d4b319a0bf0e586fbda7bfaa4.jpg";